import {
  AuthService,
  PamlabApiServiceService,
  SnackbarService,
} from '@/shared/services';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'feedback-page',
  standalone: false,
  templateUrl: './feedback-page.component.html',
  styleUrl: './feedback-page.component.css',
})
export class FeedbackPageComponent implements OnInit {
  public env = environment;

  public feedbackFormGroup = new FormGroup({
    tool_id: new FormControl('', [Validators.required]),
    feedback: new FormControl('', [Validators.required]),
  });

  public toolListWithModule: {
    module: string;
    tools: { id: number; title: string; name: string }[];
  }[] = [
    {
      module: 'Success Metrics',
      tools: [],
    },
    {
      module: 'Admin Support',
      tools: [],
    },
    {
      module: 'Admin Support External',
      tools: [],
    },
  ];

  constructor(
    private authService: AuthService,
    private apiService: PamlabApiServiceService,
    private snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.authService.fullPermissionList$.subscribe((permissions) => {
      permissions.forEach((permission) => {
        if (permission.module) {
          const found = this.toolListWithModule.find(
            (item) => item.module === permission.module,
          );
          if (found) {
            found.tools.push({
              id: permission.id,
              title: permission.tool_title!,
              name: permission.name,
            });
          }
        }
      });
    });
  }

  submitFeedback(): void {
    const { tool_id, feedback } = this.feedbackFormGroup.value;

    this.apiService
      .saveFeedback({
        tool_lookup_id: Number(tool_id!),
        feedback: feedback!,
        user_id: this.authService.getUserId()!,
      })
      .subscribe({
        next: () => {
          this.feedbackFormGroup.reset();
          this.feedbackFormGroup.setErrors(null);
          this.snackbarService.open(
            'Feedback submitted successfully!',
            'success',
          );
        },
        error: (err) => {
          console.error('Error submitting feedback:', err);
          this.snackbarService.open(
            'Error submitting feedback. Please try again later.',
            'error',
          );
        },
      });
  }
}
